export const config = {
  SIERRA_PROD_DOMAIN: "https://eu.sierra.chat",
  SIERRA_NON_PROD_DOMAIN: "https://eu.staging.sierra.chat",
  SIERRA_KEY: "fExxgdUBmA_XivcBmA_XizPvI6pWqIx8oPgqSmuZaOo",
};
